// entraauthConfig.js
const getEnv = (key, fallback = "") => {
  const value = process.env[key];
  if (typeof value !== "string") {
    return fallback;
  }

  const trimmed = value.trim();
  return trimmed || fallback;
};

const resolveEnvironmentSuffix = () => {
  const hostname = (typeof window !== "undefined" && window?.location?.hostname
    ? window.location.hostname
    : ""
  ).toLowerCase();

  if (hostname.includes("dev")) {
    return "DEV";
  }

  if (hostname.includes("tst") || hostname.includes("localhost")) {
    return "TST";
  }

  if (hostname.includes("acc")) {
    return "ACC";
  }

  return "PROD";
};

const currentEnvSuffix = resolveEnvironmentSuffix();

const getEnvForCurrentEnvironment = (baseKey, fallback = "") => {
  const scopedValue = getEnv(`${baseKey}_${currentEnvSuffix}`);
  if (scopedValue) {
    return scopedValue;
  }

  return getEnv(baseKey, fallback);
};

const resolveRedirectUri = () => {
  const configuredRedirectUri = getEnvForCurrentEnvironment("REACT_APP_ENTRA_REDIRECT_URI");
  if (configuredRedirectUri) {
    return configuredRedirectUri;
  }

  if (typeof window !== "undefined" && window?.location?.origin) {
    return `${window.location.origin}/callback`;
  }

  return "";
};

const tenantId = getEnvForCurrentEnvironment("REACT_APP_ENTRA_TENANT_ID");
const authority = getEnvForCurrentEnvironment(
  "REACT_APP_ENTRA_AUTHORITY",
  tenantId ? `https://login.microsoftonline.com/${tenantId}` : ""
).replace(/\/$/, "");

const clientId = getEnvForCurrentEnvironment("REACT_APP_ENTRA_CLIENT_ID");
const redirectUri = resolveRedirectUri();

const scopes = getEnvForCurrentEnvironment("REACT_APP_ENTRA_SCOPES", "openid profile")
  .split(/[\s,]+/)
  .map((scope) => scope.trim())
  .filter(Boolean);

if (!clientId) {
  console.error(`[ENTRA] Missing REACT_APP_ENTRA_CLIENT_ID_${currentEnvSuffix} (or REACT_APP_ENTRA_CLIENT_ID) environment variable.`);
}

if (!authority) {
  console.error(`[ENTRA] Missing REACT_APP_ENTRA_AUTHORITY_${currentEnvSuffix} / REACT_APP_ENTRA_TENANT_ID_${currentEnvSuffix} (or generic fallback) environment variable.`);
}

if (!redirectUri) {
  console.error("[ENTRA] Missing REACT_APP_ENTRA_REDIRECT_URI and unable to infer redirect URI from window.location.origin.");
}

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes
};

